import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "staking-sold-out",
	templateUrl: "./staking-sold-out.component.html",
	styleUrls: ["./staking-sold-out.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingSoldOutComponent {}
